import { render, staticRenderFns } from "./clientModalBasic.vue?vue&type=template&id=64f1eb28&scoped=true&"
import script from "./clientModalBasic.vue?vue&type=script&lang=js&"
export * from "./clientModalBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1eb28",
  null
  
)

export default component.exports